import { IMissionPlan } from '../missionPlan/IMissionPlan'
import { MissionPlanUiState } from '../../ui/MissionPlanUiState'
import { SimulationMode } from '@/enum/SimulationMode'
import { ISmartSimulationBase, getDefaultSmartSimulationBase } from './ISmartSimulationBase'
import { DepRecoMode } from '@/enum/DepRecoMode'
import { IMissionPlanWaypoint } from '../missionPlan/IMissionPlanWaypoint'
import { IArea } from './IArea'
import { getDefaultGliderCoverageConfig, IGliderCoverageConfig } from './IGliderCoverageConfig'
import { isReadyForSimulation } from './ISmartSimulation'

export interface ISmartSimulationFormation extends ISmartSimulationBase {
  gliders_config: Array<IGliderCoverageConfig>
  mission_plan: IMissionPlan
  wpt_init: Array<number> | null
  ratio_ellipse: number //Entre 0 ou 1
  rotation: number //En degre -180 - 180
  rotation_ellipse: number //En degre -180 - 180
  distance: number //En kilometre
  offsets: Array<[number, number]> //En kilometre
}

export function getDefaultSmartSimulationFormation({
  ratio_ellipse = 1,
  rotation_ellipse = 0,
  rotation = 0,
  distance = 0.5,
  templateSimId = null,
  processing_mode = SimulationMode.simulator,
  mission_start_date = '',
  glider_type = 'SEAEXPLORER',
  battery_type = 'pack 18650',
  bms_type = 'neogy',
  enable_science_files = false,
  wpt_init = null as Array<number> | null,
  surfacing_time = 300,
  mission_plan = MissionPlanUiState.getDefaultMissionPlan(),
  current_cycle = 1,
  gliders_config = [getDefaultGliderCoverageConfig()],
  offsets = [[0, 0]] as Array<[number, number]>,
} = {}): ISmartSimulationFormation {
  return {
    ...getDefaultSmartSimulationBase({
      templateSimId,
      processing_mode,
      mission_start_date,
      glider_type,
      battery_type,
      bms_type,
      enable_science_files,
      surfacing_time,
      current_cycle,
    }),
    ratio_ellipse,
    rotation,
    rotation_ellipse,
    distance,
    mission_plan,
    gliders_config,
    current_cycle,
    wpt_init,
    offsets,
  }
}

//retourne une liste de code d'erreur si le smartSimulation n'est pas valide
//si valide pour la simulation le tableau est vide
export function isReadyForSimulationFormation(data: ISmartSimulationFormation | null): Array<string> {
  const simuErrorCode = isReadyForSimulation(data)
  //ajout des tests specifiques a la formation
  //if ((data?.gliders_config?.length ?? 0) < 2) simuErrorCode.push('FormationNeedAtLeastTwoGlider')
  if ((data?.offsets?.length ?? 0) < (data?.gliders_config?.length ?? 0))
    simuErrorCode.push('FormationNeedOffsetForEachGlider')

  return simuErrorCode
}
